module.exports = __webpack_public_path__ + "16_hair_gold.7456b101.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/16_hair_gold.png
// module id = J4TK
// module chunks = 0